module.exports = __webpack_public_path__ + "media/images/element/category-1-6487f4e8091cb3b4587734cace3ec219.svg";